import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import HeaderAll from './HeaderAll';
import Footer from './Footer';

const getProgressBarColor = (percentage) => {
  if (percentage <= 30) return 'bg-red-600'; // Danger color
  if (percentage <= 70) return 'bg-yellow-600'; // Warning color
  return 'bg-green-600'; // Success color
};

const SingleDonation = () => {
  const location = useLocation();
  const navigate = useNavigate();
  console.log('Location state:', location.state); // Debugging line
  const { activity } = location.state || {}; // Retrieve data from state

  if (!activity) {
    return <div>No data available. Please return to the previous page.</div>;
  }

  const progressPercentage = (activity.raisedAmount / activity.goalAmount) * 100;
  const progressBarColor = getProgressBarColor(progressPercentage);

  return (
    <div>
      <HeaderAll />
      <div className="bg-white min-h-screen pt-[150px]">
        <div className="max-w-3xl mx-auto px-4">
          {activity.videoUrl ? (
            <video className="w-full h-80 object-cover mb-4" controls>
              <source src={activity.videoUrl} type="video/mp4" />
              Your browser does not support the video tag.
            </video>
          ) : (
            <img className="w-full h-80 object-cover mb-4" src={activity.imageUrl} alt={activity.title} />
          )}
          <h2 className="text-4xl font-glsnecb text-center mb-4">{activity.title}</h2>
          <p className="text-lg text-gray-800 mb-4">{activity.description}</p>
          <div className="mb-4">
            <div className="relative w-full h-4 bg-gray-200 rounded-full">
              <div
                className={`absolute top-0 left-0 h-4 ${progressBarColor} rounded-full`}
                style={{ width: `${progressPercentage}%` }}
              ></div>
            </div>
            <div className="text-right text-lg mt-2">
              {activity.raisedAmount}$ / {activity.goalAmount}$
            </div>
          </div>
          <button
            className="w-full py-2 text-white bg-black rounded-md"
            onClick={() => alert('Thank you for your donation!')}
          >
            Donate
          </button>
        </div>
      </div>
    </div>
  );
};

export default SingleDonation;
